import { render } from "./ClientFileEditor.vue?vue&type=template&id=6e39e6b4&scoped=true"
import script from "./ClientFileEditor.vue?vue&type=script&lang=js"
export * from "./ClientFileEditor.vue?vue&type=script&lang=js"

import "./ClientFileEditor.vue?vue&type=style&index=0&id=6e39e6b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e39e6b4"]])

export default __exports__